import { NgModule } from '@angular/core';
import { DateFormatPipe } from './services/DatesPipe';
import { FloorPipe, MillionPipe, weburlPipe } from './services/MillionPipe';
import { PhonePipe } from './services/phone.pipe';
import { SplitPipe } from './services/SplitPipe';
import { KeysPipe, LowerPipe, SafePipe, urlsPipe } from './services/safe.pipe';

@NgModule({
    imports: [],
    declarations: [
        SafePipe,
        MillionPipe,
        LowerPipe,
        PhonePipe,
        KeysPipe,
        urlsPipe, 
        FloorPipe,
        DateFormatPipe,
        SplitPipe,
        weburlPipe,
    ],
    exports: [
        SafePipe,
        MillionPipe,
        LowerPipe,
        PhonePipe,
        KeysPipe,
        urlsPipe, 
        FloorPipe,
        DateFormatPipe,
        SplitPipe,
        weburlPipe,
    ]
})

export class sharedModule { }
